/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";
import {RoleCompanyTypeMeta} from "@well/domain";
import {Observable} from "rxjs";
import {JsonApiListResourceMetadataBase, JsonApiResource} from "@irian-ro/abstract-resource";
import {RoleWithRightsDto, RoleWithRightsVo} from "@irian-ro/auth-web-client";
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Injectable({providedIn: 'root'})
export class RoleCompanyTypeResourceService{

  url: string | undefined = undefined;

  constructor(private httpClient: HttpClient, private environmentService: EnvironmentService) {
    this.url = environmentService.getEnvironmentProperty('roleCompanyTypeUrl');
  }

  getRolesByCompanyType(companyType: CompanyType): Observable<JsonApiResource<RoleWithRightsVo[], JsonApiListResourceMetadataBase>>{
    return this.httpClient.get<JsonApiResource<RoleWithRightsVo[], JsonApiListResourceMetadataBase>>(`${this.url}`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  getUserRolesByCompanyType(userUuid: string, companyType: CompanyType): Observable<JsonApiResource<RoleWithRightsVo[], JsonApiListResourceMetadataBase>>{
    return this.httpClient.get<JsonApiResource<RoleWithRightsVo[], JsonApiListResourceMetadataBase>>(`${this.url}/user/${userUuid}`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  getTemplateByCompanyType(companyType: CompanyType): Observable<JsonApiResource<RoleWithRightsDto, RoleCompanyTypeMeta>>{
    return this.httpClient.get<JsonApiResource<RoleWithRightsDto, RoleCompanyTypeMeta>>(`${this.url}/new/template`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  getTemplateFromOriginRoleByCompanyType(originRoleUuid: string, companyType: CompanyType): Observable<JsonApiResource<RoleWithRightsDto, any>>{
    return this.httpClient.get<JsonApiResource<RoleWithRightsDto, JsonApiListResourceMetadataBase>>(`${this.url}/template/origin/${originRoleUuid}`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  updateRole(roleWithRightsDto: RoleWithRightsDto): Observable<JsonApiResource<RoleWithRightsDto, any>>{
    return this.httpClient.put<JsonApiResource<RoleWithRightsDto, any>>(`${this.url}`, roleWithRightsDto);
  }

  getRoleDetailsByCompanyType(uuid: string, companyType: CompanyType): Observable<JsonApiResource<RoleWithRightsDto, RoleCompanyTypeMeta>>{
    return this.httpClient.get<JsonApiResource<RoleWithRightsDto, any>>(`${this.url}/details/${uuid}`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  saveRoleByCompanyType(role: RoleWithRightsDto): Observable<JsonApiResource<RoleWithRightsDto, any>>{
    return this.httpClient.post<JsonApiResource<RoleWithRightsDto, any>>(`${this.url}`, role);
  }

  getRolesForNewUserByCompanyType(companyType: CompanyType): Observable<JsonApiResource<RoleWithRightsVo[], any>>{
    return this.httpClient.get<JsonApiResource<RoleWithRightsVo[], any>>(`${this.url}/user/new`, {params: this.getCompanyTypeHttpParams(companyType)});
  }

  private getCompanyTypeHttpParams(companyType: CompanyType){
    let params = new HttpParams();
    if(companyType != null){
      params = params.set('companyType', companyType);
    }

    return params;
  }
}
